import { TGetRSODto } from "@/api/services/main/rso/dtos/get-rso.dto";
import { TUpdateRsoReqDto } from "@/api/services/main/rso/dtos/update-rso.dto";
import { TRsoForm } from "@/features/rso/types/rsoForm";

export const convertRsoToRsoForm = (rso: TGetRSODto): TRsoForm => {
  return {
    id: rso.id,
    name: rso.name ?? null,
    licenseNumber: rso.licenseNumber ?? null,
    hiddenIndustryIds: rso.hiddenIndustryIds ?? [],
  };
};

export const convertRsoFormDataReq = (form: TRsoForm): TUpdateRsoReqDto => {
  return {
    name: form.name,
    licenseNumber: form.licenseNumber ?? null,
    hiddenIndustryIds: form.hiddenIndustryIds ?? [],
  };
};
